export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15146.3e0bcd7b.jpg";